import { io } from 'socket.io-client';

const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || 'http://localhost:5000';

class SocketService {
  constructor() {
    this.socket = null;
    this.listeners = new Map();
  }

  connect() {
    if (this.socket?.connected) {
      console.log('Socket already connected');
      return this.socket;
    }

    this.socket = io(SOCKET_URL, {
      transports: ['websocket', 'polling'],
      reconnectionAttempts: 5,
      reconnectionDelay: 1000
    });

    this.socket.on('connect', () => {
      console.log('✅ Socket connected:', this.socket.id);
    });

    this.socket.on('disconnect', (reason) => {
      console.log('❌ Socket disconnected:', reason);
    });

    this.socket.on('connect_error', (error) => {
      console.error('Socket connection error:', error);
    });

    return this.socket;
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
      this.listeners.clear();
    }
  }

  // Listen for meter data
  onMeterData(callback) {
    if (!this.socket) {
      console.error('Socket not connected');
      return;
    }

    this.socket.on('meterData', callback);
    this.listeners.set('meterData', callback);
  }

  // Remove meter data listener
  offMeterData() {
    if (!this.socket) return;
    
    const callback = this.listeners.get('meterData');
    if (callback) {
      this.socket.off('meterData', callback);
      this.listeners.delete('meterData');
    }
  }

  // Request latest data
  requestLatestData(data) {
    if (this.socket?.connected) {
      this.socket.emit('requestLatestData', data);
    }
  }

  // Check if socket is connected
  isConnected() {
    return this.socket?.connected || false;
  }
}

// Export singleton instance
const socketService = new SocketService();
export default socketService;
